import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section-studio" }

import { computed } from 'vue';
import IconsNft from '@/components/Icon/IconsNft.vue';
import NftItemDemo from '@/components/NftItemDemo.vue';
import { GlobalStore } from '@/store/GlobalStore';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const tokenId = computed(() => parseInt(getTokenId()));
const { isMobile, } = GlobalStore;

function getTokenId(): string {
  const uris = window.location.href.split('/');
  return (uris[uris.length - 1] || '0').replace(/[^\d]/g, '');
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app", [_unref(isMobile) ? 'mobile' : 'desktop']])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(tokenId))
        ? (_openBlock(), _createBlock(NftItemDemo, {
            key: 0,
            tokenId: _unref(tokenId)
          }, null, 8, ["tokenId"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(IconsNft)
  ], 2))
}
}

})